import script from "./ProfileBaseLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileBaseLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProfileBaseLayout.vue?vue&type=style&index=0&id=01451110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01451110"]])

export default __exports__